import React, { Component } from 'react';
import { list as listAnnouncements, remove as removeAnnouncement } from '../services/announcementService';
import {
  Box,
  Paper,
  Stack,
  Typography,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Pagination,
  Chip,
  Tooltip,
  IconButton,
  Menu,
  MenuItem
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import moment from 'moment';

const STATUS_CHIPS = {
  draft: { label: 'Brouillon', color: 'default' },
  generating: { label: 'G\u00e9n\u00e9ration...', color: 'info' },
  review: { label: 'En revue', color: 'warning' },
  done: { label: 'Termin\u00e9', color: 'success' }
};

class ListAnnouncements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hits: [],
      page: 1,
      total_elem: 0,
      isLoading: false,
      menuAnchorEl: null,
      menuItem: null
    };
    this.fetchPage = this.fetchPage.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.delete = this.delete.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchPage(1);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchPage(page) {
    this.setState({ isLoading: true });
    listAnnouncements(page)
      .then((result) => {
        if (!this._isMounted) return;
        this.setState({
          hits: result.announcements || [],
          page: parseInt(result.page_nbr, 10) || page,
          total_elem: parseInt(result.total_elem, 10) || 0,
          isLoading: false
        });
      })
      .catch(() => { if (this._isMounted) this.setState({ isLoading: false }); });
  }

  onPageChange(e, value) {
    this.fetchPage(value);
  }

  delete(item) {
    if (!window.confirm(`Supprimer l'annonce "${item.title}" ?`)) return;
    removeAnnouncement(item._id).then(() => { if (this._isMounted) this.fetchPage(this.state.page); });
  }

  openMenu(item, e) {
    this.setState({ menuAnchorEl: e.currentTarget, menuItem: item });
  }

  closeMenu() {
    this.setState({ menuAnchorEl: null, menuItem: null });
  }

  getPublishedCount(drafts) {
    if (!drafts || !Array.isArray(drafts)) return '0/0';
    const published = drafts.filter((d) => d.status === 'published').length;
    return `${published}/${drafts.length}`;
  }

  render() {
    const { hits, page, total_elem } = this.state;
    const pageCount = Math.max(1, Math.ceil((total_elem || 0) / 10));

    return (
      <Box sx={{ p: 2 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between" sx={{ mb: 2 }}>
          <Typography variant="h6">Annonces</Typography>
          <Button component={RouterLink} to="/super-admin/FormAnnouncement" variant="contained" size="small">
            Nouvelle annonce
          </Button>
        </Stack>

        <Paper variant="outlined">
          <TableContainer sx={{ maxHeight: '70vh' }}>
            <Table
              size="medium"
              stickyHeader
              sx={{
                tableLayout: 'fixed',
                '& tbody tr:nth-of-type(odd)': { bgcolor: 'action.hover' }
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: '35%' }}>Titre</TableCell>
                  <TableCell sx={{ width: '15%' }}>Statut</TableCell>
                  <TableCell sx={{ width: '15%' }}>Brouillons</TableCell>
                  <TableCell sx={{ width: '20%' }}>Date</TableCell>
                  <TableCell sx={{ width: '15%' }} align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {hits.map((item) => {
                  const chip = STATUS_CHIPS[item.status] || STATUS_CHIPS.draft;
                  return (
                    <TableRow key={item._id} hover>
                      <TableCell>
                        <Tooltip title={item.title || ''}>
                          <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {item.title}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Chip size="small" label={chip.label} color={chip.color} />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">{this.getPublishedCount(item.drafts)} publi\u00e9s</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">{item.created_at ? moment(item.created_at).format('DD/MM/YYYY HH:mm') : '-'}</Typography>
                      </TableCell>
                      <TableCell align="right" sx={{ py: 0 }}>
                        <IconButton size="small" onClick={(e) => this.openMenu(item, e)} aria-label="Plus d'actions">
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {hits.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      <Typography variant="body2" color="text.secondary">Aucune annonce</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="caption" color="text.secondary">Page {page} / {pageCount}</Typography>
            <Pagination
              page={page}
              count={pageCount}
              onChange={this.onPageChange}
              size="small"
              color="primary"
              showFirstButton
              showLastButton
            />
          </Box>

          <Menu
            anchorEl={this.state.menuAnchorEl}
            open={Boolean(this.state.menuAnchorEl)}
            onClose={this.closeMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            keepMounted
          >
            <MenuItem
              component={RouterLink}
              to={this.state.menuItem ? `/super-admin/FormAnnouncement?announcement_id=${this.state.menuItem._id}` : '#'}
              onClick={this.closeMenu}
            >
              \u00c9diter
            </MenuItem>
            {this.state.menuItem && this.state.menuItem.drafts && this.state.menuItem.drafts.length > 0 && (
              <MenuItem
                component={RouterLink}
                to={this.state.menuItem ? `/super-admin/ReviewAnnouncement?announcement_id=${this.state.menuItem._id}` : '#'}
                onClick={this.closeMenu}
              >
                Voir brouillons
              </MenuItem>
            )}
            <MenuItem
              onClick={() => { if (this.state.menuItem) this.delete(this.state.menuItem); this.closeMenu(); }}
              sx={{ color: 'error.main' }}
            >
              Supprimer
            </MenuItem>
          </Menu>
        </Paper>
      </Box>
    );
  }
}

export default ListAnnouncements;
